import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTaskPriorityUrgent = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#515d71",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3.40039 0.912109C3.74544 0.912109 4.02518 1.19211 4.02539 1.53711V1.84961H13.2119C13.3584 1.8498 13.5027 1.88166 13.6348 1.94238L13.7627 2.0127L13.8789 2.10059C13.9518 2.16437 14.0154 2.23856 14.0674 2.32031L14.1367 2.44922L14.1865 2.58594C14.2264 2.72575 14.236 2.87372 14.2139 3.01855C14.1842 3.2115 14.0992 3.39204 13.9697 3.53809L13.9688 3.53906L11.8877 5.87891C11.8626 5.90707 11.8488 5.94377 11.8486 5.98145C11.8486 6.01925 11.8626 6.05666 11.8877 6.08496L13.9668 8.42676C14.0964 8.57274 14.1812 8.75335 14.2109 8.94629C14.2405 9.13933 14.2136 9.33741 14.1338 9.51562C14.0538 9.69393 13.9237 9.84582 13.7598 9.95215C13.5957 10.0584 13.4044 10.115 13.209 10.1152H4.02539V14.4619C4.02539 14.8071 3.74557 15.0869 3.40039 15.0869C3.05521 15.0869 2.77539 14.8071 2.77539 14.4619V1.53711C2.7756 1.19211 3.05534 0.912109 3.40039 0.912109ZM4.02539 8.86523H12.6846L10.9531 6.91504C10.7246 6.65793 10.5986 6.32545 10.5986 5.98145C10.5988 5.63745 10.7245 5.30487 10.9531 5.04785L12.6865 3.09961H4.02539V8.86523Z",
		fill: "currentColor"
	})
});
export default SvgTaskPriorityUrgent;
